import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./checkoutForm";
import Axios from "axios";
import { apiUri, STRIPE_PUBLISH_KEY } from "../../config";
import InjectedCheckoutForm from "./checkoutForm";
import { Grid } from "@material-ui/core";
import { FaArrowLeft } from "react-icons/fa";
import { ReportSectionHeader } from "../../common/components/SectionHeader";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import "./register.css";
import { formatCurrencyUSD } from "../../util";

// const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);

const appearance = {
  theme: "stripe",
  rules: {
    ".Label": {
      color: "#fff",
    },
  },
};

export default function PaymentComponent({
  amount,
  user,
  selectedList,
  handleBack,
  fromAceAlerts,
}) {
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    // Dynamically load Stripe only when this component is mounted
    if (!stripePromise) {
      const loadStripeLibrary = async () => {
        const { loadStripe } = await import("@stripe/stripe-js");
        setStripePromise(loadStripe(STRIPE_PUBLISH_KEY));
      };
      loadStripeLibrary();
    }
  }, [stripePromise]);

  useEffect(() => {
    const fetchClientSecret = async () => {
      Axios.get(`${apiUri}/register/initPaymentIntent?price=${amount * 100}`)
        .then((response) => {
          if (
            response.data &&
            response.data.content &&
            response.data.content.clientSecret
          ) {
            setClientSecret(response.data.content.clientSecret);
          }
        })
        .catch((error) => {
          console.log("initPaymentIntent error", error);
          NotificationManager.error(error.message, "Failure", 4000);
        });
    };

    if (stripePromise && !clientSecret) {
    fetchClientSecret();
    }
  }, [stripePromise, clientSecret]);

  const options = {
    clientSecret: clientSecret,
    appearance: appearance,
  };

  return (
    <Grid
      container
      style={{ justifyContent: "center", alignItems: "baseline" }}
    >
      <FaArrowLeft className="dateOption back_icon" onClick={handleBack} />
      <Grid item xs={12} sm={8} md={6}>
        <div style={{ margin: "0 8%", minHeight: 500 }}>
          <ReportSectionHeader>
            <h4>Selected Companies</h4>
          </ReportSectionHeader>
          <br />
          <HeaderDivider />
          <Grid container>
            {selectedList.map((company, index) => {
              return (
                <Grid
                  container
                  key={company.symbol}
                  style={{ marginBottom: "16px" }}
                >
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    md={8}
                    style={{
                      color: "#fff",
                      fontSize: "16px",
                      marginBottom: "10px",
                    }}
                  >
                    <div>{`${company.companyName} (${company.market}:${company.symbol})`}</div>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={4}
                    style={{
                      textAlign: "end",
                      color: "#fff",
                      fontSize: "16px",
                    }}
                  >
                    <div>{formatCurrencyUSD(4000)}</div>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <HeaderDivider />
          <div style={{ textAlign: "end", color: "#fff" }}>
            Total: {formatCurrencyUSD(amount)}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={8} md={4}>
        <div style={{ margin: "0 8%", minHeight: 500 }}>
          <ReportSectionHeader>
            <h4>Payment Information</h4>
          </ReportSectionHeader>
          <br />
          <HeaderDivider />
          {stripePromise && clientSecret ? (
            <Elements stripe={stripePromise} options={options}>
              <InjectedCheckoutForm
                user={user}
                selectedList={selectedList}
                fromAceAlerts={fromAceAlerts}
              />
            </Elements>
          ) : (
            <p className="loading-payment-options">
              Loading payment options...
            </p>
          )}
          <NotificationContainer />
        </div>
      </Grid>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/components/Register/payment.jsx